"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var LinkStyleImpl = require("./LinkStyle-impl").implementation;

var idlUtils = require("../generated/utils");

var domSymbolTree = require("../helpers/internal-constants").domSymbolTree;

var NODE_TYPE = require("../node-type");

var evaluateStylesheet = require("../helpers/stylesheets").evaluateStylesheet;

var documentBaseURL = require("../helpers/document-base-url").documentBaseURL;

var HTMLStyleElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLStyleElementImpl, _HTMLElementImpl);

  function HTMLStyleElementImpl() {
    _classCallCheck(this, HTMLStyleElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLStyleElementImpl).apply(this, arguments));
  }

  _createClass(HTMLStyleElementImpl, [{
    key: "_attach",
    value: function _attach() {
      if (this.type && this.type !== "text/css") {
        return;
      }

      var content = "";
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = domSymbolTree.childrenIterator(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;

          if (child.nodeType === NODE_TYPE.TEXT_NODE) {
            content += child.nodeValue;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      evaluateStylesheet(this, content, this.sheet, documentBaseURL(this._ownerDocument));

      _get(_getPrototypeOf(HTMLStyleElementImpl.prototype), "_attach", this).call(this);
    }
  }]);

  return HTMLStyleElementImpl;
}(HTMLElementImpl);

idlUtils.mixin(HTMLStyleElementImpl.prototype, LinkStyleImpl.prototype);
module.exports = {
  implementation: HTMLStyleElementImpl
};